// @flow

import React, { Component } from 'react';
import { colors, fonts } from '@peachjar/components';
import axios from 'axios';

import TempEmailTokenVerificationError from './TempEmailTokenVerificationError';
import type { Match } from 'react-router-dom';

const { prussian } = colors;
const { ProximaNova } = fonts;

// Placeholder for actual loading component
// TODO: Create Loading component
const Loading = () => <div>Loading...</div>;

type Props = {|
  token: string,
  match: Match,
|};

type State = {|
  tokenValidated: boolean,
  tokenChecked: boolean,
  tokenExpired: boolean,
  isAuthenticated: boolean,
|};

class TempEmailTokenVerification extends Component<Props, State> {
  state = {
    tokenValidated: false,
    tokenChecked: false,
    tokenExpired: false,
    isAuthenticated: false,
  };

  async componentDidMount() {
    // 1. Check the token
    const token = this.props.match.params.token;
    try {
      // 2.a if successful, show user success screen
      if (token) {
        // TODO: Revisit
        const response = await axios.get(`/email/verify/${token}`, {
          mode: 'cors',
        });

        // Check for user object
        if (response.data.user) {
          this.setState({
            tokenChecked: true,
            tokenValidated: true,
            isAuthenticated: true,
          });
        } else {
          this.setState({
            tokenChecked: true,
            tokenValidated: true,
          });
        }
      }
    } catch (error) {
      // 2.b Handle Error
      console.log('Status error', error);
      this.setState({
        tokenChecked: true,
        tokenValidated: false,
      });
    }
  }

  render() {
    {
      if (this.state.tokenChecked) {
        // Expired token or token wasn't valid
        // TODO: Create a screen for bad token?
        if (this.state.tokenExpired || !this.state.tokenValidated) {
          return <TempEmailTokenVerificationError />;
        }

        // Show success page if user is logged in
        //  In the future, send to the last page visited
        if (this.state.isAuthenticated) {
          return <div>Success Screen</div>;
        }

        // Redirect to login page if user isn't logged in
        if (!this.state.isAuthenticated) {
          return <div>Login Screen</div>;
        }

        return <div>End of line</div>;
      }

      // Show the loading screen until token is checked
      return <Loading />;
    }
  }
}

export default TempEmailTokenVerification;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/TempEmailTokenVerification.jsx